
import { useState, useEffect } from "react";
import { User } from "./types";

export const useAuthState = () => {
  // User and authentication state
  const [user, setUser] = useState<User | null>(() => {
    const savedUser = localStorage.getItem('currentUser');
    return savedUser ? JSON.parse(savedUser) : null;
  });
  
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
    return localStorage.getItem('isAuthenticated') === 'true';
  });
  
  const [selectedPackers, setSelectedPackers] = useState<string[]>(() => {
    const savedPackers = localStorage.getItem('selectedPackers');
    return savedPackers ? JSON.parse(savedPackers) : [];
  });

  // Persist state to localStorage
  useEffect(() => {
    if (user) {
      localStorage.setItem('currentUser', JSON.stringify(user));
      localStorage.setItem('isAuthenticated', 'true');
    } else {
      localStorage.removeItem('currentUser');
      localStorage.setItem('isAuthenticated', 'false');
    }
  }, [user, isAuthenticated]);

  return {
    user, 
    setUser, 
    isAuthenticated, 
    setIsAuthenticated, 
    selectedPackers, 
    setSelectedPackers
  };
};
